// extracted by mini-css-extract-plugin
export default {"heading":"CreateInterview_heading__j9Mwg"};